import { SelectOption } from 'components/Input/Select/Dropdown/Options/Option';
import { MultipleSelect, MultipleSelectTexts } from 'components/Input/Select/MultipleSelect/MultipleSelect';
import { EntityName } from 'modules/api/locHub/entity/name/name';
import { IETFLanguageCode } from 'modules/types/language/ietf/ietf';
import React, { ReactElement } from 'react';
import { Controller, UseFormMethods } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { TargetLanguagesSelectI18n } from './I18n';

interface Props {
  entity: EntityName;
  options: Map<IETFLanguageCode, SelectOption>;
  control: UseFormMethods['control'];
  errors: UseFormMethods['errors'];
}

export const TargetLanguagesSelect: React.FC<Props> = ({ entity, options, control }): ReactElement => {
  const [t] = useTranslation();
  const name = `${entity}TargetLanguages`;
  const namespace = TargetLanguagesSelectI18n.configuration.namespace;
  /* Texts */
  const texts: MultipleSelectTexts = {
    controls: {
      selectAll: t(`${namespace}.selectAll`),
      deselectAll: t(`${namespace}.deselectAll`),
      save: t(`${namespace}.save`),
    },
    options: {
      noOptions: t(`${namespace}.noOptions`),
    },
    filter: {
      placeholder: t(`${namespace}.filterPlaceholder`),
    },
    input: {
      label: t(`${namespace}.label`),
      placeholder: t(`${namespace}.placeholder`),
    },
  };
  return (
    <Controller
      name={name}
      control={control}
      rules={{
        validate: (data: Set<IETFLanguageCode> | undefined): boolean => {
          return data !== undefined && data.size > 0;
        },
      }}
      render={({ onChange, value }): ReactElement => {
        return (
          <MultipleSelect
            texts={texts}
            icon="fa-globe"
            name="targetLanguages"
            options={options}
            values={value ? new Set(value) : new Set()}
            actions={{
              valuesUpdated: onChange,
            }}
            required={true}
          />
        );
      }}
    />
  );
};
